function mockInterface(commnad) {
  switch (commnad) {
    case "uuid":
      return {
        uuid: "mock-uuid-ben-birthday-08-16-prepare-a-gift"
      };
    default:
      return null;
  }
}
export {
  mockInterface
};
